export const Roles = {
  PlatformAdmin: 'platform.admin',
  PlatformOperator: 'platform.operator',
  TenantAdmin: 'tenant.admin',
  TenantBuilder: 'tenant.builder',
  TenantReviewer: 'tenant.reviewer',
  TenantViewer: 'tenant.viewer',
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];

export const Caps = {
  CustomizePrompts: 'customizePrompts',
  AuthorCustomAgents: 'authorCustomAgents',
  AddTools: 'addTools',
  AutoApproveAllowed: 'autoApproveAllowed',
  DesignerAi: 'designerAi',
} as const;

export type Cap = (typeof Caps)[keyof typeof Caps];

export interface AccessRequirement {
  /** Any of these roles grants access. Empty/undefined = any authenticated user. */
  roles?: readonly string[];
  /** All of these caps are required (platform.admin bypasses caps). */
  caps?: readonly string[];
}

export function isPlatformRole(roles: readonly string[]): boolean {
  return roles.some((r) => r.startsWith('platform.'));
}

export function hasAccess(userRoles: readonly string[], userCaps: readonly string[], req: AccessRequirement): boolean {
  if (req.roles && req.roles.length > 0 && !req.roles.some((r) => userRoles.includes(r))) return false;
  if (req.caps && req.caps.length > 0 && !userRoles.includes(Roles.PlatformAdmin)) {
    if (!req.caps.every((c) => userCaps.includes(c))) return false;
  }
  return true;
}
